import type { ElementType } from "react"

import AssetManagementIcon from "@/icons/market-sectors/asset-management.svg"
import BlockchainsIcon from "@/icons/market-sectors/blockhains.svg"
import BridgesIcon from "@/icons/market-sectors/bridges.svg"
import DerivativesIcon from "@/icons/market-sectors/derivatives.svg"
import ExchangesIcon from "@/icons/market-sectors/exchange.svg"
import GamingIcon from "@/icons/market-sectors/gaming.svg"
import InfraIcon from "@/icons/market-sectors/infra.svg"
import InsuranceIcon from "@/icons/market-sectors/insurance.svg"
import LaunchpadIcon from "@/icons/market-sectors/launchpad.svg"
import LendingIcon from "@/icons/market-sectors/lending.svg"
import LiquidStakingIcon from "@/icons/market-sectors/liquid-staking.svg"
import MevMarketplaceIcon from "@/icons/market-sectors/mev-marketplace.svg"
import NftIcon from "@/icons/market-sectors/nft.svg"
import PredictionMarketIcon from "@/icons/market-sectors/prediction-market.svg"
import StablecoinIssuerIcon from "@/icons/market-sectors/stablecoin-issuer.svg"
import MarketsIcon from "@/icons/markets-filled.svg"

export const getMarketIcon = (id: string): ElementType => {
  switch (id) {
    case "asset-management":
      return AssetManagementIcon
    case "blockchains-l1":
    case "blockchains-l2":
      return BlockchainsIcon
    case "bridges":
      return BridgesIcon
    case "derivatives":
      return DerivativesIcon
    case "exchange":
      return ExchangesIcon
    case "gaming":
      return GamingIcon
    case "infrastructure":
      return InfraIcon
    case "insurance":
      return InsuranceIcon
    case "launchpad":
      return LaunchpadIcon
    case "lending":
      return LendingIcon
    case "liquid-staking":
      return LiquidStakingIcon
    case "mev":
      return MevMarketplaceIcon
    case "nft":
      return NftIcon
    case "prediction-markets":
      return PredictionMarketIcon
    case "stablecoin":
      return StablecoinIssuerIcon
    default:
      return MarketsIcon
  }
}
